import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import App from "./App";

// Standard client-side rendering (CSR)
const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
     <BrowserRouter>  {/* Wrap with BrowserRouter for client-side routing */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
